module.exports = __webpack_public_path__ + "img/logo.e0e55943.png";